/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : GithubSWMLogs.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
  Toolbar,
  AppBar,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import LaunchSharpIcon from "@mui/icons-material/LaunchSharp";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

import {
  CustomButton,
  CustomTextFieldN,
  CustomUpdateDialog,
} from "../../components";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { toast } from "react-toastify";
import appTheme from "../../assets/AppTheme/appTheme";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { HandleApiActions, labCar } from "../../redux/actions";
import githubIntegrationAction from "../../redux/actions/githubIntegrationAction";
import GithubTableDialog from "../../components/customComponentsV2/vlc/github/GithubTableDialog";
import CustomDialogBoxV2 from "../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
import CustomFormTextFieldV2 from "../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";
import CustomButtonV2 from "../../components/customComponentsV2/common/button/CustomButtonV2";
import { componentStyle } from "../../config/appTheme";
import ruleEngineActions from "../../redux/actions/ruleEngineAction";
import CustomSelectV2 from "../../components/customComponentsV2/common/select/CustomSelectV2";
import typeApprovalAPI from "../../redux/actions/typeApprovalAPI";
import DecisionMatrixPanel from "../legal-requirements/RuleCenter/Executions/DecisionMatrixPanel";
import AttributeUpdateDialog from "./Attributes/AttributeUpdateDialog";

function GithubSWMLogs({
  setGitSWMLogsDetails,
  handleMenuAction,
  gitSWMLogsDetails,
  openGitSWMDialog,
  setOpenGitSWMDialog,
  selectedVariantsMany,
  variantOptionList,
  selectedProjectDetails,
  selectedEEComponentDetails,
  handleSWModuleUpdate,
  setIsLinkSoftwareModulesScreen,
  selectedZone,
  selectedSWM,
  getSWModulesList,
  selectedSingleVariantDetails,
  checkForStandardWithRuleSet,
  sWModulesList,
}) {
  //useState
  useEffect(() => {
  }, []);


  const [selectedSWModuleUpdateDetails, setSelectedSWModuleUpdateDetails] =
    useState(null);
  const [openSWModuleUpdateDialog, setOpenSWModuleUpdateDialog] =
    useState(false);
  const [isHasTag, setIsHasTag] = useState(false);
  const [updateResponse, setUpdateResponse] = useState({});
  const [linkedMetaId, setLinkedMetaId] = useState(null);

  // Table column configuration for easy width control
  const columns = [
    { id: "sno", label: "S.No", width: 50 },
    { id: "details", label: "Details", width: 220 },
    { id: "message", label: "Commited Message", width: 220 },
    { id: "by", label: "Commited By", width: 220 },
    { id: "branch", label: "Branch", width: 100 },
    { id: "created", label: "Created At", width: 200 },
    { id: "committed", label: "Commited At", width: 200 },
    { id: "action", label: "Action", width: 100 },
  ];

  const handleClose = () => {
    setOpenGitSWMDialog(false);
    setGitSWMLogsDetails([]);
  };

  const handleClickApprove = (req) => {

    setLinkedMetaId(req?.linked_meta_id);

    const hasTag =
      typeof req?.linked_meta_details?.ref === "string" &&
        req?.linked_meta_details?.ref?.startsWith("refs/tags/")
        ? true
        : false;
    setIsHasTag(hasTag);

    if (hasTag) {
      setOpenSWModuleUpdateDialog(true);
      setSelectedSWModuleUpdateDetails(req);
      setOpenGitSWMDialog(false);
    } else {
      setOpenSWModuleUpdateDialog(true);
      setSelectedSWModuleUpdateDetails(req);
      setOpenGitSWMDialog(false);
    }
  };



  //function to identify unix to UTC date
  function unixToUTCDate(seconds) {
    if (seconds == null) return null;

    const num = Number(seconds);
    if (!Number.isFinite(num)) return null;

    const ms = num > 1e12 ? num : num * 1000;
    const date = new Date(ms);

    if (isNaN(date.getTime())) return null;

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "UTC", // 🔥 ensures UTC
    });
  }

  //function to redirect to commit link
  function redirectToCommit(payload) {
    const commitUrl = payload?.linked_meta_details?.head_commit?.url;

    if (!commitUrl) return;

    window.open(commitUrl, "_blank", "noopener,noreferrer");
  }
  useEffect(() => {
  }, [gitSWMLogsDetails]);
  return (
    <div>
      <CustomDialogBoxV2
        open={openGitSWMDialog}
        onClose={handleClose}
        title={"GitHub Commit"}
      >
        <Box>
          <TableContainer
            sx={{
              borderRadius: 0,
              boxShadow: 1,
              border: "1px solid #e0e0e0",
              maxHeight: 440,
              scrollbarColor: "#6c6e70ff #f1f1f1",
              overflowX: "auto",
            }}
          >
            <Table stickyHeader sx={{ tableLayout: "fixed" }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                  {columns.map((col) => (
                    <TableCell
                      key={col.id}
                      sx={{
                        color: "#53565A",
                        width: col.width,
                        minWidth: col.width,
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {gitSWMLogsDetails?.length > 0 ? (
                  gitSWMLogsDetails?.map((item, idx) => {
                    const visibility =
                      item?.linked_meta_details?.repository?.visibility || "";
                    const isPublic = visibility === "PUBLIC";
                    const branch =
                      item?.linked_meta_details?.repository?.default_branch;
                    const createdAt = item.created_at
                      ? new Date(item.created_at).toLocaleString()
                      : "";
                    const releasedAt = item?.released_at
                      ? new Date(item.released_at).toLocaleString()
                      : "";

                    return (
                      <TableRow key={item.id || idx} sx={{ color: "#333" }}>
                        <TableCell
                          sx={{
                            width: columns[0].width,
                            minWidth: columns[0].width,
                          }}
                        >
                          {idx + 1}
                        </TableCell>
                        <TableCell
                          sx={{
                            width: columns[1].width,
                            minWidth: columns[1].width,
                            wordBreak: "break-word",
                          }}
                        >
                          Owner:{" "}
                          {item?.linked_meta_details?.repository?.owner?.name}
                          <br />
                          Visibility: {visibility} <br />
                          Repository:{" "}
                          {item?.linked_meta_details?.repository?.name} <br />
                          Tag/Path: {item?.linked_meta_details?.ref} <br />
                          Type:{" "}
                          {typeof item?.linked_meta_details?.ref === "string" &&
                            item?.linked_meta_details?.ref.startsWith(
                              "refs/tags/",
                            )
                            ? "Tag"
                            : "Branch"}{" "}
                          <br />
                        </TableCell>
                        <TableCell
                          sx={{
                            width: columns[2].width,
                            minWidth: columns[2].width,
                            wordBreak: "break-word",
                          }}
                        >
                          {item?.linked_meta_details?.head_commit?.message}
                        </TableCell>
                        <TableCell
                          sx={{
                            width: columns[3].width,
                            minWidth: columns[3].width,
                          }}
                        >
                          {item?.linked_meta_details?.head_commit?.committer
                            ?.email || "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            width: columns[4].width,
                            minWidth: columns[4].width,
                          }}
                        >
                          {branch}
                        </TableCell>
                        <TableCell
                          sx={{
                            width: columns[5].width,
                            minWidth: columns[5].width,
                          }}
                        >
                          {createdAt}
                        </TableCell>
                        <TableCell
                          sx={{
                            width: columns[6].width,
                            minWidth: columns[6].width,
                          }}
                        >
                          {unixToUTCDate(
                            item?.linked_meta_details?.repository?.pushed_at,
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            width: columns[7].width,
                            minWidth: columns[7].width,
                          }}
                        >
                          <Box sx={{ display: "flex" }}>
                            <IconButton
                              onClick={() => handleClickApprove(item)}
                              sx={{ color: "black" }}
                              // sx={styles.closeButton}
                              disabled={
                                !(
                                  Number(
                                    Array.isArray(sWModulesList)
                                      ? sWModulesList?.find(
                                        (m) =>
                                          String(m?.swm_id) ===
                                          String(item?.swm_id),
                                      )?.action_type
                                      : sWModulesList?.action_type,
                                  ) === 0 ||
                                  Number(
                                    Array.isArray(sWModulesList)
                                      ? sWModulesList?.find(
                                        (m) =>
                                          String(m?.swm_id) ===
                                          String(item?.swm_id),
                                      )?.action_type
                                      : sWModulesList?.action_type,
                                  ) === 3
                                )
                              }
                            >
                              <CheckIcon />
                            </IconButton>
                            <IconButton
                              onClick={() => redirectToCommit(item)}
                              sx={{ color: "#515253ff" }}
                            // sx={styles.closeButton}
                            >
                              <LaunchSharpIcon />
                            </IconButton>
                          </Box>
                          {/* <CustomButton
                          startIcon={<CheckCircleOutlineIcon />}
                          size="medium"
                          variant="contained"
                          btnName={"Approve"}
                          handleOnClick={() => handleClickApprove(item)}
                        /> */}
                        </TableCell>
                        {/* <TableCell>
                        {item?.linked_meta_details?.repository?.owner?.name}
                      </TableCell> */}
                        {/* <TableCell>
                        <Chip
                          label={visibility}
                          color={isPublic ? "success" : "warning"}
                          icon={
                            isPublic ? (
                              <CheckCircleOutlineIcon />
                            ) : (
                              <CloseIcon />
                            )
                          }
                          size="small"
                          sx={{ fontWeight: "bold", color: "#fff" }}
                        />
                      </TableCell> */}
                        {/* <TableCell>
                        <Chip
                          label={branch}
                          color="primary"
                          size="small"
                          sx={{ fontWeight: "bold", color: "#fff" }}
                        />
                      </TableCell> */}
                        {/* <TableCell>{createdAt}</TableCell> */}
                        {/* <TableCell>
                        <span style={{ fontWeight: "bold" }}>Name:</span>{" "}
                        {item?.linked_meta_details?.head_commit?.committer
                          ?.name || "-"}
                        <br />
                        <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
                        {item?.linked_meta_details?.head_commit?.committer
                          ?.email || "-"}
                      </TableCell> */}
                        {/* <TableCell>
                        {item?.linked_meta_details?.head_commit?.message}
                      </TableCell> */}
                        {/* <TableCell>{item?.linked_meta_details?.ref}</TableCell> */}
                        {/* <TableCell>
                        {typeof item?.linked_meta_details?.ref === "string" &&
                        item?.linked_meta_details?.ref.startsWith("refs/tags/")
                          ? "Tag"
                          : "Branch"}
                      </TableCell> */}
                        {/* <TableCell>{releasedAt}</TableCell> */}
                        {/* <TableCell>
                        <CustomButton
                          startIcon={<CheckCircleOutlineIcon />}
                          size="medium"
                          variant="contained"
                          btnName={"Approve"}
                          handleOnClick={() => handleClickApprove(item)}
                        />
                      </TableCell> */}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <Typography>No Logs Found</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </CustomDialogBoxV2>
      {/* <Dialog
        open={openGitSWMDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pr: 1,
            fontWeight: "bold",
            fontSize: "1.25rem",
            backgroundColor: "#f5f5f5",
          }}
        >
          GitHub Software Module Commits
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[600],
              ml: 2,
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#fafcff", p: 3 }}>
          <TableContainer
            sx={{
              borderRadius: 2,
              boxShadow: 1,
              border: "1px solid #e0e0e0",
              maxHeight: 440,
              scrollbarColor: "#90caf9 #f1f1f1",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                  {[
                    "S.No",
                    "Repository Name",
                    "Owner Details",
                    "Visibility",
                    "Default Branch",
                    "Created At",
                    "Committer Details",
                    "Committed Message",
                    "Tags",
                    "Type",
                    "Last Commit At",
                    "Stats",
                  ].map((data) => (
                    <TableCell key={data} sx={{ fontWeight: "bold" }}>
                      {data}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {gitSWMLogsDetails?.length > 0 ? (
                  gitSWMLogsDetails?.map((item, idx) => {
                    const visibility =
                      item?.linked_meta_details?.repository?.visibility?.toUpperCase() ||
                      "";
                    const isPublic = visibility === "PUBLIC";
                    const branch =
                      item?.linked_meta_details?.repository?.default_branch;
                    const createdAt = item.created_at
                      ? new Date(item.created_at).toLocaleString()
                      : "";
                    const releasedAt = item?.released_at
                      ? new Date(item.released_at).toLocaleString()
                      : "";

                    return (
                      <TableRow key={item.id || idx}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>
                          {item?.linked_meta_details?.repository?.name}
                        </TableCell>
                        <TableCell>
                          {item?.linked_meta_details?.repository?.owner?.name}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={visibility}
                            color={isPublic ? "success" : "warning"}
                            icon={
                              isPublic ? (
                                <CheckCircleOutlineIcon />
                              ) : (
                                <CloseIcon />
                              )
                            }
                            size="small"
                            sx={{ fontWeight: "bold", color: "#fff" }}
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={branch}
                            color="primary"
                            size="small"
                            sx={{ fontWeight: "bold", color: "#fff" }}
                          />
                        </TableCell>
                        <TableCell>{createdAt}</TableCell>
                        <TableCell>
                          <span style={{ fontWeight: "bold" }}>Name:</span>{" "}
                          {item?.linked_meta_details?.head_commit?.committer
                            ?.name || "-"}
                          <br />
                          <span style={{ fontWeight: "bold" }}>
                            Email:
                          </span>{" "}
                          {item?.linked_meta_details?.head_commit?.committer
                            ?.email || "-"}
                        </TableCell>
                        <TableCell>
                          {item?.linked_meta_details?.head_commit?.message}
                        </TableCell>
                        <TableCell>{item?.linked_meta_details?.ref}</TableCell>
                        <TableCell>
                          {typeof item?.linked_meta_details?.ref === "string" &&
                          item?.linked_meta_details?.ref.startsWith(
                            "refs/tags/"
                          )
                            ? "Tag"
                            : "Branch"}
                        </TableCell>
                        <TableCell>{releasedAt}</TableCell>

                        <TableCell>
                          <CustomButton
                            startIcon={<CheckCircleOutlineIcon />}
                            size="medium"
                            variant="contained"
                            btnName={"Approve"}
                            handleOnClick={() => handleClickApprove(item)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <Typography textAlign={"center"}>No logs found</Typography>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog> */}
      {/* <GithubTableDialog
        open={openGitSWMDialog}
        handleClose={handleClose}
        gitSWMLogsDetails={gitSWMLogsDetails.length > 0 ?gitSWMLogsDetails : [] }
      /> */}
      <VlcSWModuleUpdateDialog
        linkedMetaId={linkedMetaId}
        setUpdateResponse={setUpdateResponse}
        isHasTag={isHasTag}
        selectedVariantsMany={selectedVariantsMany}
        variantOptionList={variantOptionList}
        selectedProjectDetails={selectedProjectDetails}
        selectedEEComponentDetails={selectedEEComponentDetails}
        openSWModuleUpdateDialog={openSWModuleUpdateDialog}
        setOpenSWModuleUpdateDialog={setOpenSWModuleUpdateDialog}
        handleSWModuleUpdate={handleSWModuleUpdate}
        selectedSWModuleUpdateDetails={selectedSWModuleUpdateDetails}
        setSelectedSWModuleUpdateDetails={setSelectedSWModuleUpdateDetails}
        setIsLinkSoftwareModulesScreen={setIsLinkSoftwareModulesScreen}
        selectedZone={selectedZone}
        selectedSWM={selectedSWM}
        getSWModulesList={getSWModulesList}
        selectedSingleVariantDetails={selectedSingleVariantDetails}
        checkForStandardWithRuleSet={checkForStandardWithRuleSet}
      />
    </div>
  );
}

export default GithubSWMLogs;

function VlcSWModuleUpdateDialog({
  linkedMetaId,
  isHasTag,
  variantOptionList,
  openSWModuleUpdateDialog,
  setOpenSWModuleUpdateDialog,
  handleSWModuleUpdate,
  selectedSWModuleUpdateDetails,
  setSelectedSWModuleUpdateDetails,
  setIsLinkSoftwareModulesScreen,
  selectedZone,
  selectedEEComponentDetails,
  getSWModulesList,
  selectedProjectDetails,
  selectedSingleVariantDetails,
  selectedVariantsMany,
  setUpdateResponse,
  // checkForStandardWithRuleSet,
}) {
  const navigate = useNavigate();
  /* Update SW Modules Fields */
  const [version, setVersion] = useState("");
  const [oldVersion, setOldVersion] = useState("");
  const [versionError, setVersionError] = useState("");
  const [showAttributeConfirmation, setShowAttributeConfirmation] =
    useState(false);
  const [openUpdateFlowAttributeDialog, setOpenUpdateFlowAttributeDialog] =
    useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false); // State to track confirmation dialog
  const linkModuleType = { SWM: 1, EE: 2 };
  const [discp, setDiscp] = useState("");
  const [discpError, setDiscpError] = useState("");
  const [actionType1DialogOpen, setActionType1DialogOpen] = useState(false);
  const [selectedSWM, setSelectedSWM] = useState(null);
  const [ticketsDialogOpen, setTicketsDialogOpen] = useState(false);

  const dispatch = useDispatch();

  const [showIntersectionImpactPrompt, setShowIntersectionImpactPrompt] =
    useState(false);
  const [actionType2DialogOpen, setActionType2DialogOpen] = useState(false);

  // Rule set selection + questions flow (mirrors SWModules)
  const [showRuleSetListDialog, setShowRuleSetListDialog] = useState(false);
  const [ruleSetList, setRuleSetList] = useState([]);
  const [selectedRuleSet, setSelectedRuleSet] = useState("");
  const [showRuleSetQuestionDialog, setShowRuleSetQuestionDialog] =
    useState(false);
  const [ruleSetTree, setRuleSetTree] = useState(null);
  const [rulePath, setRulePath] = useState([]); // [{ node: {type,data}, answer: 'yes'|'no'|null }]
  const [showDecisionMatrix, setShowDecisionMatrix] = useState(false);
  const [decisionMatrixContext, setDecisionMatrixContext] = useState(null);
  const [executionId, setExecutionId] = useState(null);

  const [similarTickets, setSimilarTickets] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [openAiPanel, setOpenAiPanel] = useState(false);
  const [createTicketData, setCreateTicketData] = useState({});
  const [disabledStandards, setDisabledStandards] = useState([]);
  const selectedAttributeComponent = {
    ...(selectedSWM || {}),
    ...(selectedSWModuleUpdateDetails || {}),
    attributes:
      selectedSWM?.attributes || selectedSWModuleUpdateDetails?.attributes || [],
  };

  const approveGitSWMLog = async () => {
    const reqObj = {
      project_id: Number(selectedSWModuleUpdateDetails?.project_id),
      variant_id: Number(selectedSingleVariantDetails?.variant_id),
      ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
      swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
      linked_meta_id: Number(linkedMetaId),
    };

    const res = await dispatch(
      HandleApiActions({
        ...githubIntegrationAction.approve_git_swm_logs,
        params: reqObj,
      }),
    );

    if (!res.error) {
      toast.success("Approved");
    }

    return res;
  };
  const handleRuleSetListDialogClose = () => {
    setShowRuleSetListDialog(false);
    setSelectedRuleSet("");
  };

  const handleAnswerAt = (idx, answer) => {
    if (!rulePath || idx < 0 || idx >= rulePath.length) return;
    const newPath = rulePath
      .slice(0, idx + 1)
      .map((entry, i) => (i === idx ? { ...entry, answer } : entry));

    const currentEntry = newPath[idx];
    const nextBranch = currentEntry?.node?.data?.[answer + "_branch"];

    if (nextBranch) {
      newPath.push({ node: nextBranch, answer: null });
      setRulePath(newPath);
    } else {
      // If we have a category (terminal), we remain until Finish
      setRulePath(newPath);
    }
  };

  const viewRuleSetQuestions = async (ruleSetIdParam) => {
    const ruleSetIdToUse = ruleSetIdParam || selectedRuleSet;
    try {
      const response = await dispatch(
        HandleApiActions({
          ...ruleEngineActions.get_rule_set_tree,
          params: { rule_set_id: ruleSetIdToUse },
          show_toast: false,
        }),
      );
      if (response?.data) {
        setRuleSetTree(response.data);
        const root = response.data?.tree
          ? { type: "question", data: response.data.tree }
          : null;
        if (root) {
          setRulePath([{ node: root, answer: null }]);
          setShowRuleSetQuestionDialog(true);
        }
        setShowRuleSetListDialog(false);
      }
    } catch (error) {
      console.error("Failed to fetch rule set questions", error);
    }
  };

  // Drive the rule-set check using the parent-provided function
  const handleRuleSetCheck = async () => {
    try {
      const data = await checkForStandardWithRuleSet?.();
      const list = Array.isArray(data) ? data : [];
      if (list.length > 0) {
        setRuleSetList(list);
        setShowRuleSetListDialog(true);
      } else {
        // If no rulesets available, proceed with plain update
        await updateChangesAndClose();
      }
    } catch (e) {
      console.error("Rule set check failed", e);
    }
  };

  const handleCloseSWModuleUpdateDialog = () => {
    setOpenSWModuleUpdateDialog(false);
  };

  const checkForStandardWithRuleSet = async () => {
    const reqObj = {
      project_id: Number(selectedSWModuleUpdateDetails?.project_id),
      variant_id: Number(selectedSingleVariantDetails?.variant_id),
      ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
      swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
      tickets_type: 1,
    };

    try {
      // First API call
      const response = await dispatch(
        HandleApiActions({
          ...typeApprovalAPI.get_tickets,
          params: reqObj,
          show_toast: false,
        }),
      );
      setShowIntersectionImpactPrompt(false);
      setShowConfirmation(false); // Reset confirmation on close
      setOpenSWModuleUpdateDialog(false);

      // Extract and deduplicate standards
      const standardsWithRuleSet = [
        ...new Set(
          Array.isArray(response?.data)
            ? response.data
              ?.map((ticket) => ticket?.ls_details?.standard_number)
              ?.filter((std) => Boolean(std)) // remove empty/undefined
            : [],
        ),
      ];

      if (standardsWithRuleSet?.length > 0) {
        // Second API call with standards
        const standardWithRuleSet = await dispatch(
          HandleApiActions({
            ...ruleEngineActions?.get_rule_engine_with_standards,
            params: { standard: standardsWithRuleSet },
            show_toast: false,
          }),
        );

        if (
          standardWithRuleSet?.data &&
          (Array.isArray(standardWithRuleSet.data)
            ? standardWithRuleSet.data?.length > 0
            : Object.keys(standardWithRuleSet?.data)?.length > 0)
        ) {
          // Handle the case where there are standards with rulesets
          handleCloseSWModuleUpdateDialog();
          setShowRuleSetListDialog(true);
          // store the full rule objects so we can send the id later
          setRuleSetList(standardWithRuleSet?.data);
        } else {
          handleCloseSWModuleUpdate();
          updateChangesWithoutStandardAndClose();
        }
        return standardWithRuleSet.data || [];
      } else {
        updateChangesAndClose();
        return [];
      }
    } catch (error) {
      console.error("Failed to fetch standard with ruleset", error);
      return false;
    }
  };

  const updateChangesWithoutStandardAndClose = async () => {
    const reqObj = {
      current_time: new Date().toISOString(),
      variant_ids: selectedEEComponentDetails?.variant_ids,
      project_id: Number(selectedSWModuleUpdateDetails?.project_id),
      variant_id: Number(selectedSingleVariantDetails?.variant_id),
      ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
      swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
      version,
      will_it_impact: false,
      requires_homologation: false,
      reason: discp,
    };

    try {
      const response = await dispatch(
        HandleApiActions({
          ...labCar.update_sw_module,
          params: reqObj,
          show_toast: true,
        }),
      );

      setDiscp("");


      if (response?.data?.snow_resp) {
        // small delay ensures backdrop cleanup
        setTimeout(() => {
          setTicketsDialogOpen(true);
        }, 200);
      }

      await dispatch(
        HandleApiActions({
          ...labCar.get_sw_modules,
          params: {
            project_id: Number(selectedSWModuleUpdateDetails?.project_id),
            ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
            variant_id: Number(selectedSingleVariantDetails?.variant_id),
            zone: selectedZone,
          },
          show_toast: false,
        }),
      );
    } catch (error) {
      console.error("Failed to update", error);
    }
  };

  const isDecisionMatrixContextValid = (data) => {
    if (!data?.standards || data.standards.length === 0) {
      return false;
    }

    return data.standards.some((standard) => {
      if (!standard.rule_sets || standard.rule_sets.length === 0) {
        return false;
      }

      return standard.rule_sets.some(
        (ruleSet) => ruleSet.workflows && ruleSet.workflows.length > 0,
      );
    });
  };

  const loadDecisionMatrixContext = async () => {
    const reqObj = {
      project_id: Number(selectedSWModuleUpdateDetails?.project_id),
      variant_id: Number(selectedSingleVariantDetails?.variant_id),
      ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
      swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
      linked_meta_id: Number(linkedMetaId),
    };
    const res = await dispatch(
      HandleApiActions({
        ...githubIntegrationAction.approve_git_swm_logs,
        params: reqObj,
      }),
    );
    if (!res.error) {
      toast.success("Approved");
    }
    // 1. Fetch context based on component
    const standardsRes = await dispatch(
      HandleApiActions({
        ...ruleEngineActions.decision_matrix_get_context,
        params: {
          component_type: "SWM",
          component_id: selectedSWModuleUpdateDetails.swm_id,
          project_id: selectedProjectDetails.project_id,
          variant_id: selectedSingleVariantDetails.variant_id,
        },
        show_toast: false,
      }),
    );
    setOpenSWModuleUpdateDialog(false);
    setShowConfirmation(false); // Reset confirmation on close
    setShowIntersectionImpactPrompt(false);

    const contextData = standardsRes?.data;


    const isValid = isDecisionMatrixContextValid(contextData);

    if (!isValid) {
      console.warn(
        "Invalid decision matrix context, cannot proceed:",
        contextData,
      );
      setDecisionMatrixContext(null);
      setShowDecisionMatrix(false);
      return;
    }

    setDecisionMatrixContext(standardsRes?.data);

    setShowDecisionMatrix(true);
  };

  const handleExecuteWorkflow = async ({ mode, payload }) => {
    if (mode === "START") {
      const res = await dispatch(
        HandleApiActions({
          ...ruleEngineActions.wfe_execution_start,
          params: {
            workflowId: payload.workflowId,
            version: payload.version,
          },
          show_toast: false,
        }),
      );

      setExecutionId(res.executionId);

      return res;
    }

    if (mode === "COMPLETE") {
      const res = await dispatch(
        HandleApiActions({
          ...ruleEngineActions.wfe_execution_node_complete,
          params: {
            executionId: payload.executionId,
            nodeId: payload.nodeId,
            input: payload.input,
          },
          show_toast: false,
        }),
      );

      return res;
    }

    throw new Error(`Unsupported execution mode: ${mode}`);
  };

  const handleViewExecution = (executionId) => {
    // navigate / open drawer / open audit view
  };

  const updateComponentAndCheckForDecisionMatrix = async ({
    standardCode,
  } = {}) => {
    try {
      const reCreateTicketParams = {
        details: createTicketData,
      };

      const res = await dispatch(
        HandleApiActions({
          ...ruleEngineActions.re_create_ticket_v1,
          params: reCreateTicketParams,
          show_toast: true,
        }),
      );

      if (!res?.error && standardCode) {
        handleTicketCreationSuccess(standardCode);
      }
      return res;
      // Once updated, check if decision matrix needs to be shown.
    } catch (error) {
      console.error("Failed to update", error);
    }
  };

  useEffect(() => {
    if (openSWModuleUpdateDialog === true && selectedSWModuleUpdateDetails) {
      if (isHasTag) {
        setVersion(
          selectedSWModuleUpdateDetails?.linked_meta_details?.ref?.split(
            "tags/",
          )[1] || "",
        );
        setDiscp(
          selectedSWModuleUpdateDetails?.linked_meta_details?.head_commit
            ?.message,
        );
      } else {
        setOldVersion(selectedSWModuleUpdateDetails?.version || "");
        setDiscp(
          selectedSWModuleUpdateDetails?.linked_meta_details?.head_commit
            ?.message,
        );
      }

    }
  }, [openSWModuleUpdateDialog, selectedSWModuleUpdateDetails]);

  /* -------------- Update SW Module -------------- */

  const clearUpdateSWModuleFields = () => {
    setVersion("");
    setVersionError("");
    setDiscp("");
    setDiscpError("");
  };

  const isUpdateSWModuleValid = () => {
    return (
      !versionError &&
      version?.trim() !== selectedSWModuleUpdateDetails?.version &&
      version?.trim()?.length >= 3 &&
      discp?.trim()?.length >= 3
    );
  };

  const handleCloseSWModuleUpdate = () => {
    setOpenSWModuleUpdateDialog(false);

    clearUpdateSWModuleFields();

    setSelectedSWModuleUpdateDetails(null);
    setShowAttributeConfirmation(false);
    setOpenUpdateFlowAttributeDialog(false);
    setShowConfirmation(false); // Reset confirmation on close
    setShowIntersectionImpactPrompt(false);
  };

  const handleUpdateClick = () => {
    setShowAttributeConfirmation(true);
  };

  const handleUpdateSWModule = ({ }) => {
    if (
      selectedSWModuleUpdateDetails &&
      selectedSWModuleUpdateDetails?.swm_id
    ) {
      handleSWModuleUpdate({
        swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
        version: version,
      });

      handleCloseSWModuleUpdate();
    }
  };

  const handleAttributeImpactYes = async () => {
    setShowAttributeConfirmation(false);

    const reqObj = {
      current_time: new Date().toISOString(),
      project_id: Number(selectedSWModuleUpdateDetails?.project_id),
      variant_id: Number(selectedSingleVariantDetails?.variant_id),
      ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
      swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
      version,
      will_it_impact: true,
      variant_ids: selectedEEComponentDetails?.variant_ids,
      reason: discp,
    };

    try {
      const response = await dispatch(
        HandleApiActions({
          ...labCar.update_sw_module,
          params: reqObj,
          show_toast: true,
        }),
      );

      setUpdateResponse(response);

      if (response?.error) {
        return;
      }

      await dispatch(
        HandleApiActions({
          ...labCar.update_action_type,
          params: {
            current_time: new Date().toISOString(),
            project_id: Number(selectedSWModuleUpdateDetails?.project_id),
            variant_id: Number(selectedSingleVariantDetails?.variant_id),
            ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
            swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
            is_dependency_linking: false,
            attribute: true,
          },
          show_toast: false,
        }),
      );

      await approveGitSWMLog();
      getSWModulesList({ force: true });
      setOpenSWModuleUpdateDialog(false);
      setTimeout(() => {
        setOpenUpdateFlowAttributeDialog(true);
      }, 200);
    } catch (error) {
      console.error("Failed to update attribute impact", error);
    }
  };

  const confirmUpdateAndRedirect = async ({
    selectedSWModuleUpdateDetails,
    willImptIntrOnly = false,
  }) => {

    const reqObj = {
      current_time: new Date().toISOString(),
      project_id: Number(selectedSWModuleUpdateDetails?.project_id),
      variant_id: Number(selectedSingleVariantDetails?.variant_id),
      ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
      swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
      version: version,
      will_it_impact: true,
      variant_ids: selectedEEComponentDetails?.variant_ids,
      reason: discp,
    };
    try {
      // Dispatch the update action type API action
      const response = await dispatch(
        HandleApiActions({
          ...labCar.update_sw_module,
          params: reqObj,
          show_toast: true,
        }),
      );
      setUpdateResponse(response);
      if (!response.error) {
        handleCloseSWModuleUpdate();
        willImptIntrOnly
          ? handleActionType2DialogOpen()
          : handleActionType1DialogOpen();
        if (willImptIntrOnly) {
          const resp = await dispatch(
            HandleApiActions({
              ...labCar.update_action_type,
              params: {
                current_time: new Date().toISOString(),
                project_id: Number(selectedSWModuleUpdateDetails?.project_id),
                variant_id: Number(selectedSingleVariantDetails?.variant_id),
                ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
                swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
                is_dependency_linking: true,
              },
              show_toast: false,
            }),
          );
        }
        getSWModulesList({ force: true });
        await approveGitSWMLog();
      }
    } catch (error) {
      console.error("Failed to update", error);
    }
  };

  const updateChangesAndClose = async () => {
    const reqObj = {
      current_time: new Date().toISOString(),
      variant_ids: selectedEEComponentDetails?.variant_ids,
      project_id: Number(selectedSWModuleUpdateDetails?.project_id),
      variant_id: Number(selectedSingleVariantDetails?.variant_id),
      ee_id: Number(selectedSWModuleUpdateDetails?.ee_id),
      swm_id: Number(selectedSWModuleUpdateDetails?.swm_id),
      version: version,
      will_it_impact: false,
      // If rule path exists, pick requires_homologation from last category node
      requires_homologation:
        (rulePath?.length > 0 &&
          rulePath[rulePath.length - 1]?.node?.data?.requires_homologation) ||
        false,
      reason: discp,
    };
    try {
      const response = await dispatch(
        HandleApiActions({
          ...labCar.update_sw_module,
          params: reqObj,
          show_toast: true,
        }),
      );
      getSWModulesList({ force: true });
      if (!response.error) {
        handleCloseSWModuleUpdate();
      }
      if (response?.data?.snow_resp) {
        setTicketsDialogOpen(true);
      }

      // Approve the Git SWM log after a successful update (mirror confirm path)
      try {
        await approveGitSWMLog();
      } catch (e) {
        console.error("Git SWM approve failed", e);
      }
    } catch (error) {
      console.error("Failed to update", error);
    }
  };

  const handleActionType1DialogOpen = () => {
    setSelectedSWM(selectedSWModuleUpdateDetails);
    setActionType1DialogOpen(true);
  };
  const handleActionType1DialogClose = () => {
    setActionType1DialogOpen(false);
  };

  const handleActionType2DialogOpen = () => {
    setSelectedSWM(selectedSWModuleUpdateDetails);
    setActionType2DialogOpen(true);
  };

  const handleActionType2DialogClose = () => {
    setActionType2DialogOpen(false);
  };

  const handleTicketsDialogClose = () => {
    setTicketsDialogOpen(false);
    setDiscp("");
  };

  const handleTicketCreationSuccess = (standardCode) => {
    setDisabledStandards((prev) => [...new Set([...prev, standardCode])]);
  };

  //function to handel a get a list of tickets for a legal requirements
  const handelGetSimilerTickets = async ({ standard_name } = {}) => {
    try {
      const reCreateTicketParams = {
        execution_id: executionId,
        entity_type: "swm",
        entity_id: Number(selectedSWModuleUpdateDetails?.swm_id),
        ...(standard_name != null ? { standard_name } : {}),
      };

      const res = await dispatch(
        HandleApiActions({
          ...ruleEngineActions.get_similar_tickets,
          params: reCreateTicketParams,
          show_toast: true,
        }),
      );

      setSimilarTickets(res?.data || []);
      setCreateTicketData(res?.data || []);
      return res;
    } catch (error) {
      console.error("Failed to update", error);
    }
  };

  const handelGetAiSuggestion = (ticket) => {
    setSelectedEntity({
      type: "INTERSECTION",
      id: ticket?.intr_id,
      targetEntityTypes: ["ARTIFACT"],
      topK: 20,
      minConfidence: 0.6,
      description: "SW Module",
    });
    setOpenAiPanel(true);
  };

  const handelCloseDecisionMatrix = () => {
    setShowDecisionMatrix(false);
    setDecisionMatrixContext(null);
    setRulePath([]);
    setSimilarTickets([]);
    setSelectedEntity(null);
    setSelectedTicket(null);
    setCreateTicketData({});
    setDisabledStandards([]);
  };
  return (
    <Box>
      <CustomDialogBoxV2
        open={openSWModuleUpdateDialog}
        onClose={handleCloseSWModuleUpdate}
        title={"Update Software Module"}
        dialogActions={
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
            <CustomButtonV2
              btnName={"Cancel"}
              size="small"
              type="cancel"
              handleOnClick={handleCloseSWModuleUpdate}
            // disabled={!isUpdateSWModuleValid()}
            />
            <CustomButtonV2
              btnName={"Update"}
              size="small"
              type="submit"
              handleOnClick={handleUpdateClick}
              disabled={!isUpdateSWModuleValid()}
            />
          </Box>
        }
      >
        <Stack spacing={2} mb={2} sx={{ width: "350px", height: "150px" }}>
          {!isHasTag ? (
            <CustomFormTextFieldV2
              disabled={true}
              size={"small"}
              label={"Old Version"}
              // type={"text"}
              // fldType={"textR"}
              value={oldVersion}
              setValue={setOldVersion}
            // valueError={versionError}
            // setValueError={setVersionError}
            // variant={"standard"}
            // txtFldStyle={{ width: "270px" }}
            />
          ) : null}

          <CustomFormTextFieldV2
            required={true}
            size={"small"}
            label={"New Version"}
            // placeholder={"New Version*"}
            type={"text"}
            // fldType={"textR"}
            value={version}
            setValue={(value) => value.length <= 40 && setVersion(value)}
            // valueError={versionError}
            // setValueError={setVersionError}
            // variant={"standard"}
            // txtFldStyle={{ width: "270px" }}
            maxLength={40}
          />
          {/* <MultiSelectFieldVariants
              mutiple
              selectedValues={selectedVariantsMany}
              setSelectedValues={setSelectedVariantsMany}
              label={"Select Variants"}
              optionsList={variantOptionList?.filter(
                (variants) =>
                  variants?.value !== selectedSingleVariantDetails?.variant_id
              )}
              sltFldStyle={styles.customTextFieldN}
            /> */}
          <CustomFormTextFieldV2
            required={true}
            size={"small"}
            label={"Reason"}
            // placeholder={"Reason to update*"}
            // type={"text"}
            // fldType={"textO"}
            value={discp}
            setValue={(value) => value.length <= 100 && setDiscp(value)}
            // valueError={discpError}
            // setValueError={setDiscpError}
            // variant={"standard"}
            // txtFldStyle={{ width: "270px" }}
            maxLength={100}
          />
          <CustomDialogBoxV2
            open={showAttributeConfirmation}
            onClose={() => {
              setShowAttributeConfirmation(false);
            }}
            title="Action"
            dialogActions={
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <CustomButtonV2
                  btnName="No"
                  size="small"
                  type="cancel"
                  handleOnClick={() => {
                    setShowAttributeConfirmation(false);
                    setTimeout(() => {
                      setShowConfirmation(true);
                    }, 200);
                  }}
                />
                <CustomButtonV2
                  btnName="Yes"
                  size="small"
                  type="submit"
                  handleOnClick={handleAttributeImpactYes}
                />
              </Box>
            }
          >
            <Box
              sx={{
                width: "350px",
                height: "50px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: "15px" }}>
                Will it impact the existing attributes?
              </Typography>
            </Box>
          </CustomDialogBoxV2>
          {/* {showConfirmation && (
            <Stack spacing={2}>
              <Typography variant="body1">
                Will it impact the existing dependencies?
              </Typography>
              <Stack direction="row" spacing={2} justifyContent={"center"}>
                <Button
                  sx={{ ...appTheme.commonBtnStyle }}
                  onClick={() =>
                    confirmUpdateAndRedirect({
                      selectedSWModuleUpdateDetails,
                    })
                  }
                >
                  Yes
                </Button>

                <Button
                  sx={{ ...appTheme.commonBtnStyle }}
                  onClick={() => {
                    setShowConfirmation(false);
                    setShowIntersectionImpactPrompt(true);
                  }}
                >
                  No
                </Button>
              </Stack>
            </Stack>
          )}

          {showIntersectionImpactPrompt && (
            <Stack spacing={2}>
              <Typography variant="body1">
                Will it impact the existing intersection?
              </Typography>
              <Stack direction="row" spacing={2} justifyContent={"center"}>
                <Button
                  sx={{ ...appTheme.commonBtnStyle }}
                  onClick={() =>
                    confirmUpdateAndRedirect({
                      selectedSWModuleUpdateDetails,
                      willImptIntrOnly: true,
                    })
                  }
                >
                  Yes
                </Button>
                <Button
                  sx={{ ...appTheme.commonBtnStyle }}
                  onClick={updateChangesAndClose}
                >
                  No
                </Button>
              </Stack>
            </Stack>
          )} */}

          <CustomDialogBoxV2
            open={showConfirmation}
            onClose={() => {
              setShowConfirmation(false);
            }}
            title={"Action"}
            dialogActions={
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <CustomButtonV2
                  btnName={"No"}
                  size="small"
                  type="cancel"
                  handleOnClick={() => {
                    setShowConfirmation(false);
                    setTimeout(() => {
                      setShowIntersectionImpactPrompt(true);
                    }, 200);
                  }}
                />
                <CustomButtonV2
                  btnName={"Yes"}
                  size="small"
                  type="submit"
                  handleOnClick={() => {
                    confirmUpdateAndRedirect({
                      selectedSWModuleUpdateDetails,
                    });
                  }}
                />
              </Box>
            }
          >
            <Box
              sx={{
                width: "350px",
                height: "50px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  // ...componentStyle.font.text,
                  fontSize: "15px",
                }}
              >
                Will it impact the existing dependencies?
              </Typography>
            </Box>
          </CustomDialogBoxV2>

          <CustomDialogBoxV2
            open={showIntersectionImpactPrompt}
            onClose={() => {
              setShowIntersectionImpactPrompt(false);
            }}
            title="Action"
            dialogActions={
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <CustomButtonV2
                  size="small"
                  type="cancel"
                  btnName="No"
                  handleOnClick={() => {
                    loadDecisionMatrixContext();
                    updateChangesWithoutStandardAndClose();
                  }}
                />
                <CustomButtonV2
                  size="small"
                  type="submit"
                  btnName="Yes"
                  handleOnClick={() =>
                    confirmUpdateAndRedirect({
                      selectedSWModuleUpdateDetails,
                      willImptIntrOnly: true,
                    })
                  }
                />
              </Box>
            }
          >
            <Box
              sx={{
                width: "350px",
                height: "50px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  // ...componentStyle.font.text,
                  fontSize: "15px",
                }}
              >
                Will it impact the existing intersection?
              </Typography>
            </Box>
          </CustomDialogBoxV2>
        </Stack>
      </CustomDialogBoxV2>

      <AttributeUpdateDialog
        openAttributeUpdateDialog={openUpdateFlowAttributeDialog}
        setOpenAttributeUpdateDialog={setOpenUpdateFlowAttributeDialog}
        handleCloseAttributeUpdateDialog={() => {
          setOpenUpdateFlowAttributeDialog(false);
        }}
        onClickSuccess={() => {
          getSWModulesList({ force: true });
          setOpenUpdateFlowAttributeDialog(false);
        }}
        selectedComponent={selectedAttributeComponent}
        componentType={"swm"}
        isAttributeImpactFlow
        variantId={selectedSingleVariantDetails?.variant_id}
        onIntersectionNo={loadDecisionMatrixContext}
        attributeImpactActionType={{ dependency: true }}
        onAttributeImpactComplete={() => {
          getSWModulesList({ force: true });
          setOpenUpdateFlowAttributeDialog(false);
          setSelectedSWM(selectedSWModuleUpdateDetails);
          setActionType1DialogOpen(true);
        }}
      />

      {/* Rule set list dialog */}
      <CustomDialogBoxV2
        open={showRuleSetListDialog}
        onClose={handleRuleSetListDialogClose}
        title="Select Rule Set"
        onClickSuccess={async () => {
          // fetch and open the question flow for the selected ruleset
          await viewRuleSetQuestions(selectedRuleSet);
          // keep the list dialog closed
          setShowRuleSetListDialog(false);
        }}
        onDisabled={!selectedRuleSet}
        onClickReject={handleRuleSetListDialogClose}
        actionButtonStyle={"continuous"}
        successButtonName={"Confirm"}
        rejectButtonName={"Cancel"}
      >
        <Stack spacing={2} sx={{ width: "350px", height: "50px" }}>
          <CustomSelectV2
            size={"small"}
            label={"Select Rule Set"}
            required={true}
            // variant={"standard"}
            optionsList={
              ruleSetList?.map((rs) => ({
                value: rs?.rule_set_id || rs?.id,
                label: rs?.name,
              })) || []
            }
            selectedValue={selectedRuleSet || " "}
            handleOnChange={(e) => setSelectedRuleSet(e.target.value)}
          // sltFldStyle={{ width: "100%", marginTop: 6 }}
          />
        </Stack>
      </CustomDialogBoxV2>

      {/* <Dialog
        open={showRuleSetListDialog}
        onClose={handleRuleSetListDialogClose}
      >
        <DialogTitle align="left">Select Rule Set</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ minWidth: 320 }}>
            <TextField
              select
              size="small"
              label="Select Rule Set"
              value={selectedRuleSet}
              onChange={(e) => setSelectedRuleSet(e.target.value)}
            >
              {ruleSetList?.map((rs) => (
                <MenuItem
                  key={rs?.rule_set_id || rs?.id}
                  value={rs?.rule_set_id || rs?.id}
                >
                  {rs?.name}
                </MenuItem>
              ))}
            </TextField>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button
                sx={{ ...appTheme.commonBtnStyle }}
                onClick={handleRuleSetListDialogClose}
              >
                Cancel
              </Button>
              <Button
                sx={{ ...appTheme.commonBtnStyle }}
                onClick={() => viewRuleSetQuestions(selectedRuleSet)}
                disabled={!selectedRuleSet}
              >
                Confirm
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog> */}

      {/* Rule set question dialog */}
      <CustomDialogBoxV2
        open={showRuleSetQuestionDialog}
        onClose={() => {
          setShowRuleSetQuestionDialog(false);
          setRuleSetTree(null);
          setRulePath([]);
          setSelectedRuleSet("");
        }}
        title={`Rule Set: ${ruleSetTree?.name || ""}`}
        contentSx={{ minHeight: "350px", width: "450px" }}
      // onClickSuccess={async () => {
      //   // fetch and open the question flow for the selected ruleset
      //   await viewRuleSetQuestions(selectedRuleSet);
      //   // keep the list dialog closed
      //   setShowRuleSetListDialog(false);
      // }}
      // onDisabled={!selectedRuleSet}
      // onClickReject={handleRuleSetListDialogClose}
      // actionButtonStyle={"continuous"}
      // successButtonName={"Confirm"}
      // rejectButtonName={"Cancel"}
      >
        <DialogContent>
          <Stack spacing={2} sx={{}}>
            {/* Full path view - show all questions answered so far and allow editing */}
            <Stack spacing={1}>
              {rulePath?.map((entry, idx) => {
                const isCategory = entry.node?.type === "category";
                return (
                  <Box
                    key={idx}
                    sx={{
                      border: "1px solid #e0e0e0",
                      p: 1,
                      borderRadius: 1,
                      backgroundColor:
                        idx === rulePath?.length - 1 ? "#fafafa" : "white",
                    }}
                  >
                    {!isCategory ? (
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {entry.node?.data?.text}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Box>
                            <CustomButtonV2
                              // size="small"
                              // variant={
                              //   entry.answer === "yes"
                              //     ? "contained"
                              //     : "outlined"
                              // }
                              btnName={"Yes"}
                              handleOnClick={() => handleAnswerAt(idx, "yes")}
                              {...(entry.answer === "yes"
                                ? { type: "submit" }
                                : { type: "cancel" })}

                            // sx={{
                            //   ...appTheme.commonBtnStyle,
                            //   mr: 1,
                            //   ...(entry.answer === "no" && {
                            //     color: "#888",
                            //     borderColor: "#d0d0d0",
                            //     backgroundColor: "#f5f5f5",
                            //     "&:hover": {
                            //       backgroundColor: "#eeeeee",
                            //       borderColor: "#c0c0c0",
                            //     },
                            //   }),
                            // }}
                            />
                          </Box>
                          <Box>
                            <CustomButtonV2
                              // size="small"
                              // variant={
                              //   entry.answer === "no" ? "contained" : "outlined"
                              // }
                              btnName={"No"}
                              handleOnClick={() => handleAnswerAt(idx, "no")}
                              {...(entry.answer === "no"
                                ? { type: "submit" }
                                : { type: "cancel" })}

                            // sx={{
                            // ...appTheme.commonBtnStyle,
                            // ...(entry.answer === "yes" && {
                            //   color: "#888",
                            //   borderColor: "#d0d0d0",
                            //   backgroundColor: "#f5f5f5",
                            //   "&:hover": {
                            //     backgroundColor: "#eeeeee",
                            //     borderColor: "#c0c0c0",
                            //   },
                            // })
                            // }}
                            />
                          </Box>
                        </Box>
                      </Stack>
                    ) : (
                      <Stack>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          Session Ended: {entry.node?.data?.description}
                        </Typography>
                        {/* <Typography variant="caption" color="text.secondary">
                                  Requires homologation:{" "}
                                  {String(entry.node?.data?.requires_homologation === true)
                                    ? "required"
                                    : "not required"}
                                </Typography> */}
                      </Stack>
                    )}
                  </Box>
                );
              })}

              {/* If last node is category show Finish, otherwise allow answering last question if unanswered */}
              {
                rulePath?.length > 0 &&
                  rulePath[rulePath?.length - 1]?.node?.type === "category" ? (
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    mt={2}
                  >
                    <CustomButtonV2
                      type="submit"
                      btnName={"Finish"}
                      // sx={{ ...appTheme.commonBtnStyle }}
                      handleOnClick={() => {
                        // Check if the last node requires homologation
                        const lastNode = rulePath[rulePath?.length - 1]?.node;

                        if (lastNode?.data?.requires_homologation) {
                          // If homologation is required, just call the updateChangesAndClose function and close the dialog
                          updateChangesAndClose();
                          setShowRuleSetQuestionDialog(false);
                          setRuleSetTree(null);
                          setRulePath([]);
                          setSelectedRuleSet("");
                          handleCloseSWModuleUpdate();
                        } else {
                          // If homologation is not required, just close the dialog
                          updateChangesAndClose();
                          setShowRuleSetQuestionDialog(false);
                          setRuleSetTree(null);
                          setRulePath([]);
                          setSelectedRuleSet("");
                          handleCloseSWModuleUpdate();
                        }
                      }}
                    />
                  </Stack>
                ) : null
                // if last entry exists and has no answer, show primary controls
                // rulePath?.length > 0 && (
                //   <Stack
                //     direction="row"
                //     spacing={2}
                //     justifyContent="center"
                //     mt={2}
                //   >
                //     <Button
                //       sx={{ ...appTheme.commonBtnStyle }}
                //       onClick={() =>
                //         handleAnswerAt(rulePath.length - 1, "yes")
                //       }
                //       disabled={
                //         !rulePath[rulePath.length - 1]?.node?.data?.yes_branch
                //       }
                //     >
                //       Yes
                //     </Button>
                //     <Button
                //       sx={{ ...appTheme.commonBtnStyle }}
                //       onClick={() =>
                //         handleAnswerAt(rulePath.length - 1, "no")
                //       }
                //       disabled={
                //         !rulePath[rulePath.length - 1]?.node?.data?.no_branch
                //       }
                //     >
                //       No
                //     </Button>
                //   </Stack>
                // )
              }
            </Stack>
          </Stack>
        </DialogContent>
      </CustomDialogBoxV2>

      {/* <Dialog
        open={showRuleSetQuestionDialog}
        onClose={() => {
          setShowRuleSetQuestionDialog(false);
          setRuleSetTree(null);
          setRulePath([]);
          setSelectedRuleSet("");
        }}
      >
        <DialogTitle>Rule Set: {ruleSetTree?.name || ""}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ minWidth: 360 }}>
            <Stack spacing={1}>
              {rulePath?.map((entry, idx) => {
                const isCategory = entry.node?.type === "category";
                return (
                  <Box
                    key={idx}
                    sx={{
                      border: "1px solid #e0e0e0",
                      p: 1,
                      borderRadius: 1,
                      backgroundColor:
                        idx === rulePath.length - 1 ? "#fafafa" : "white",
                    }}
                  >
                    {!isCategory ? (
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {entry.node?.data?.text}
                          </Typography>
                        </Box>
                        <Box>
                          <Button
                            size="small"
                            variant={
                              entry.answer === "yes" ? "contained" : "outlined"
                            }
                            onClick={() => handleAnswerAt(idx, "yes")}
                            sx={{ ...appTheme.commonBtnStyle, mr: 1 }}
                          >
                            Yes
                          </Button>
                          <Button
                            size="small"
                            variant={
                              entry.answer === "no" ? "contained" : "outlined"
                            }
                            onClick={() => handleAnswerAt(idx, "no")}
                            sx={{ ...appTheme.commonBtnStyle }}
                          >
                            No
                          </Button>
                        </Box>
                      </Stack>
                    ) : (
                      <Stack>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          Session Ended: {entry.node?.data?.description}
                        </Typography>
                      </Stack>
                    )}
                  </Box>
                );
              })}

              {rulePath?.length > 0 &&
              rulePath[rulePath.length - 1]?.node?.type === "category" ? (
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  mt={2}
                >
                  <Button
                    sx={{ ...appTheme.commonBtnStyle }}
                    onClick={async () => {
                      // Finish → update with will_it_impact=false and requires_homologation derived
                      await updateChangesAndClose();
                      setShowRuleSetQuestionDialog(false);
                      setRuleSetTree(null);
                      setRulePath([]);
                      setSelectedRuleSet("");
                    }}
                  >
                    Finish
                  </Button>
                </Stack>
              ) : null}
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog> */}

      <Box>
        {/* Action Pending Dialog */}
        {/* <Dialog
          open={actionType1DialogOpen}
          onClose={handleActionType1DialogClose}
          BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
          <DialogTitle align="left">Action required</DialogTitle>
          <IconButton
            onClick={handleActionType1DialogClose}
            sx={styles.closeButton}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <Stack spacing={2}>
              <Typography variant="body1" align="center">
                Software module dependency linking is pending!
              </Typography>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Link
                  to={`/dashboard/labcar?swm_id=${selectedSWM?.swm_id}&ee_id=${selectedEEComponentDetails?.ee_id}&selectedZone=${selectedZone?.zone_position_name}&linkModuleType=${linkModuleType?.SWM}`}
                  style={{ textDecoration: "none" }}
                >
                  <CustomButtonV2
                    type="submit"
                    btnName="Link Now"
                    handleOnClick={() => setIsLinkSoftwareModulesScreen(true)}
                  />
                </Link>

                <CustomButtonV2
                  type="submit"
                  btnName="Link Later"
                  handleOnClick={handleActionType1DialogClose}
                />
              </Stack>
            </Stack>
          </DialogContent>
        </Dialog> */}

        {/* Action Pending Dialog */}
        {/* <Dialog
          open={actionType2DialogOpen}
          onClose={handleActionType2DialogClose}
          BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
          <DialogTitle align="left">Action required</DialogTitle>
          <IconButton
            onClick={handleActionType2DialogClose}
            sx={styles.closeButton}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <Stack spacing={2}>
              <Typography variant="body1" align="center">
                Software module intersection linking is pending!
              </Typography>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Link
                  to={`/dashboard/type-approval?project_id=${selectedProjectDetails?.project_id}&variant_id=${selectedSingleVariantDetails?.variant_id}&ee_id=${selectedEEComponentDetails?.ee_id}&selectedZone=${selectedZone?.zone_position_name}&swm_id=${selectedSWM?.swm_id}&linkModuleType=${linkModuleType?.SWM}`}
                >
                  <Button
                    sx={{ ...appTheme.commonBtnStyle }}
                    onClick={handleActionType2DialogClose}
                  >
                    Link Now
                  </Button>
                </Link>
                <Button
                  sx={{ ...appTheme.commonBtnStyle }}
                  onClick={handleActionType2DialogClose}
                >
                  Link Later
                </Button>
              </Stack>
            </Stack>
          </DialogContent>
        </Dialog> */}

        {/* Handle Ticket Page Dialog */}
        <CustomDialogBoxV2
          open={ticketsDialogOpen}
          onClose={handleTicketsDialogClose}
          title={"Tickets Recreated"}
          dialogActions={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <CustomButtonV2
                btnName="Close"
                handleOnClick={handleTicketsDialogClose}
                type="cancel"
              />
              <CustomButtonV2
                btnName="View"
                handleOnClick={() => {
                  navigate(`/dashboard/v2/type-approval/tickets?tab=${1}`);
                  setTicketsDialogOpen(false);
                }}
              />
            </Box>
          }
        >
          <Box
            sx={{
              width: "350px",
              height: "50px",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Typography
              sx={{
                // ...componentStyle.font.text,
                fontSize: "15px",
              }}
            >
              Successfully created the tickets for the intersections!
            </Typography>
          </Box>
        </CustomDialogBoxV2>

        {/* <Dialog
          open={ticketsDialogOpen}
          onClose={handleTicketsDialogClose}
          BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
          <DialogTitle align="left">Tickets Recreated</DialogTitle>
          <DialogContent>
            <Stack spacing={2}>
              <Typography variant="body1" align="center">
                Successfully created the tickets for the intersections!
              </Typography>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Link
                  to={`/dashboard/type-approval?project_id=${
                    selectedProjectDetails?.project_id
                  }&setTabValue=${2}&varint_id=${
                    selectedSingleVariantDetails?.variant_id
                  }`}
                >
                  <Button sx={{ ...appTheme.commonBtnStyle }}>View</Button>
                </Link>

                <Button
                  sx={{ ...appTheme.commonBtnStyle }}
                  onClick={handleTicketsDialogClose}
                >
                  Close
                </Button>
              </Stack>
            </Stack>
          </DialogContent>
        </Dialog> */}
        <Dialog
          open={showDecisionMatrix}
          onClose={handelCloseDecisionMatrix}
          fullScreen
          PaperProps={{
            sx: {
              width: "100vw",
              height: "100vh",
              margin: 0,
              borderRadius: 0,
            },
          }}
        >
          {/* Deloitte AppBar */}
          <AppBar
            position="sticky"
            sx={{
              backgroundColor: "#26890D",
            }}
          >
            <Toolbar>
              <Typography variant="h6" sx={{ flexGrow: 1 }}>
                Decision Matrix
              </Typography>
              <IconButton color="inherit" onClick={handelCloseDecisionMatrix}>
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>

          {/* Body */}
          <Box
            sx={{
              flex: 1,
              height: "calc(100vh - 64px)",
              overflow: "auto",
              p: 2,
            }}
          >
            <DecisionMatrixPanel
              context={decisionMatrixContext}
              onExecuteWorkflow={handleExecuteWorkflow}
              onViewExecution={handleViewExecution}
              onClose={handelCloseDecisionMatrix}
              onDecisionMatrixAction={updateComponentAndCheckForDecisionMatrix}
              ///////////////////////
              handelGetSimilerTickets={handelGetSimilerTickets}
              similarTickets={similarTickets}
              setSimilarTickets={setSimilarTickets}
              entityDetails={selectedEntity}
              handelGetAiSuggestion={handelGetAiSuggestion}
              selectedTicket={selectedTicket}
              setSelectedTicket={setSelectedTicket}
              openAiPanel={openAiPanel}
              setOpenAiPanel={setOpenAiPanel}
              setCreateTicketData={setCreateTicketData}
              disabledStandards={disabledStandards}
            />
          </Box>
        </Dialog>
      </Box>
    </Box>
  );
}

// Styles
const styles = {
  closeButton: {
    color: "black",
    position: "absolute",
    top: { xs: "2px", sm: "4px" },
    right: { xs: "4px", sm: "8px" },
  },
  swmCompMainContainer: {
    flex: 1,
    minWidth: 0,
    minHeight: { xs: "350px", sm: "500px", md: "575px" },
    maxHeight: { xs: "500px", sm: "600px", md: "700px" },
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "stretch",
    boxSizing: "border-box",
  },
  card: {
    flex: 1,
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    boxShadow: 4,
    borderRadius: "3%",
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    py: { xs: 0.5, sm: 0.5 },
    backgroundColor: "lightgrey",
    borderBottom: "1px solid lightgrey",
    borderRadius: "2%",
    // "& .MuiTypography-root": {
    //   fontSize: { xs: "0.6rem", sm: "0.9rem" },
    // },
  },
  cardContent: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    scrollbarColor: "#888 #f1f1f1",
    scrollbarWidth: "thin",
    px: { xs: 0.5, sm: 1 },
    py: { xs: 0.5, sm: 1 },
  },
  cardItems: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: { xs: 0.5, sm: 1 },
    pl: { xs: 0.5, sm: 1 },
    pr: { xs: 0.2, sm: 0.5 },
    backgroundColor: "background.paper",
    borderRadius: 2,
    boxShadow: 1,
    cursor: "pointer",
    minHeight: { xs: 44, sm: 54 },
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    border: "1px solid lightgrey",
  },
  cardItemsTxtContainer: {
    // flexGrow: 1,
    textAlign: "start",
    my: { xs: 0.5, sm: 1 },
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    // display: "flex",
    // flexDirection: "column",
    gap: 0.5,
    // fontSize: { xs: "0.75rem", sm: "0.85rem" },
  },
  noDataAvailableTxt: {
    textAlign: "center",
    mt: { xs: 1, sm: 2 },
    fontSize: { xs: "0.9rem", sm: "1rem" },
  },
  customTextFieldN: {
    width: { xs: "140px", sm: "180px", md: "220px" },
    fontSize: { xs: "0.85rem", sm: "0.95rem" },
  },
  cardActions: {
    display: "flex",
    justifyContent: "flex-end",
    borderTop: "1px solid lightgrey",
    px: { xs: 0.5, sm: 1 },
    py: { xs: 0.5, sm: 1 },
  },
  edRpIconsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: { xs: 0.5, sm: 1 },
  },
  paginationPaper: {
    display: "flex",
    justifyContent: "flex-end",
    p: { xs: "2px", sm: "3px" },
  },
};
